<div class="loading-overlay" *ngIf="loadingService.loading$ | async">
  <div class="spinner"></div>
</div>